import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'
import { t } from 'i18next'
import { useLazyQuery } from '@apollo/client';
import { GET_BOAT_STATUS } from 'graphql/boat/queries';

export function BoatStatusDropdown({ value, onChange, onBlur, error, helperText, purpose }) {

  const [boatStatusList, setBoatStatusList] = useState(null)

  const [getBoatStatusList, { loading: statusListLoading, error: statusListError }] = useLazyQuery(GET_BOAT_STATUS, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    onCompleted: data => {
      if (data.boatStatus.length > 0) {
        setBoatStatusList(data.boatStatus)
      }
    },
  })

  // get Type List
  const getBoatStatus = () => {
    getBoatStatusList({
      variables: {
        "code": null
      },
    })
  }
  useEffect(() => {
    getBoatStatus();
  }, []);

  return (
    <>
      {/* {statusListLoading && <div className="flex justify-center items-center bg-white py-5">Loading ....</div>} */}
      {statusListError && (
        <div className="flex justify-center items-center bg-white py-5">
          <div className="text-lg text-center">{t('Failed to fetch status')}</div>
        </div>
      )}
      {!statusListLoading && !statusListError && boatStatusList?.length === 0 && (
        <div className="flex justify-center items-center bg-white py-5">
          <div className="text-lg text-center">{t('No status found!')}</div>
        </div>
      )}
      {!statusListLoading && !statusListError && boatStatusList?.length > 0 && (
        <select
          id="status"
          name="status"
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
        >
          {purpose === 'filter' ? <option value={null}> {t('All')} </option> : <option value="" disabled> {t('Select Status')} </option>}
          {boatStatusList.map((boatStatus) => (
            <option key={boatStatus.code} value={boatStatus.code}>
              {boatStatus.description.en}
            </option>
          ))}
        </select>

      )}
      {error && <p className="text-error text-xs mt-1">
        {helperText}
      </p>}


    </>
  );
}

